/**
 * Created by Tiger on 09/06/2022.
 */
import React, {FC, useContext, useState} from "react";
import {Center, Column, PrimaryButton} from "./lib";
import InputWithLabel from "./InputWithLabel";
import {Button, message} from "antd";
import styled from "@emotion/styled";
import {Link, useHistory, useRouteMatch} from "react-router-dom";
import {ContextProps, LoginType, MobileLoginContext} from "./index";
import {getStrQueryVariable} from "../../../common/util";
import i18n from "i18next";
import Back from "./Back";

interface PasswordProps {
  account: string;
  loginType: LoginType;
  countryCode?: string;
}

export function getErrorDescription(code: number): string {
  let description = ''
  switch (code) {
    case 1001:
      description = i18n.t('login_failed_account_not_exist')
      break
    case 1010:
      description = i18n.t('login_failed_pwd_error')
      break
    case -4780:
      description = i18n.t('verification_code_error')
      break
    case -4469:
    case -4781:
      description = i18n.t('login_fail')
      break;
  }
  return description
}

const Password: FC<PasswordProps> = (props) => {
  const {params} = useRouteMatch()
  const [password, setPassword] = useState('');
  const {account, countryCode, loginType} = params as PasswordProps
  const context = useContext(MobileLoginContext);
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const login = () => {
    setLoading(true)
    const {cid = '', loginWithPassword, updateAuth,} = context as ContextProps
    loginWithPassword({account, password, cid, country_code: countryCode})?.then(res => {
        console.log('登录成功：', res)
        if (!!cid && res.data?.data?.redirect) {
          updateAuth({
            redirectUrl: res.data.data.redirect.split('?')[0],
            code: getStrQueryVariable('code', res.data.data.redirect),
            access_key: getStrQueryVariable('access_key', res.data.data.redirect) || '',
            cid: cid,
            nonce:getStrQueryVariable('nonce', res.data.data.redirect)
          })
        } else {
          const {code = -2000} = res?.data || {}
          message.error(getErrorDescription(code))
          setLoading(false)
        }
      }
    ).catch(error => {
      setLoading(false)
      console.log('登录失败', error)
      message.error(i18n.t('login_fail'))
    })
  }

  return <Column>
    <Back onClick={() => history.goBack()} title={i18n.t('title_input_pwd')}/>
    <Title>{i18n.t('input_password_tip').replace('%@', `${loginType === 'Email' ? '' : `+${countryCode} `} ${account}`)}</Title>
    <InputWithLabel
      onPressEnter={login}
      isPasswordInput={true}
      placeholder={i18n.t('password')}
      style={{marginTop: 30}}
      value={password}
      onChange={event => {
        setPassword(event.target.value)
      }}
    />
    <PrimaryButton disabled={password.length < 6} type={"primary"} loading={loading} style={{marginTop: 80}}
                   onClick={login}>{i18n.t('login')}</PrimaryButton>
    <Center>
      <Button type={"link"} style={{marginTop: 20}}>
        <Link to={`/login/mobile/verificationCode/${account}/${loginType}/${countryCode}`}>{i18n.t('via_verify')}</Link>
      </Button>
    </Center>

  </Column>
}

export default Password


const Title = styled.div`
  margin-top: 60px;
  font-weight: 700;
`
